import { FontListForAnnotations } from "./font-list";
import { OBJECT_TYPES } from "../constants/project";
import { openCenterPopup } from "../helpers/app";

export const AnnotationObject = {
  objectType: OBJECT_TYPES.ANNOTATION,
  attributes: [
    {
      name: "text",
      defaultValue: null,
      validation: [],
      type: "textarea",
      validValues: [],
      disabled: false,
      autoFocus: true,
      showName: "value",
      rows: 4,
      hint: `you can use html formatting tags: \`<b>\`, \`<i>\`, \`<u>\`, \`<a href=""..></a>\`, \`<font color=..>\``,
    },
    {
      name: "x",
      defaultValue: null,
      validation: [{ required: true, message: "Please input the x!" }],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "y",
      defaultValue: null,
      validation: [{ required: true, message: "Please input the y!" }],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "width",
      defaultValue: null,
      validation: [],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "height",
      defaultValue: null,
      validation: [],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "alignment",
      defaultValue: null,
      validation: [],
      type: "select",
      validValues: [
        {
          label: "left",
          value: "left",
        },
        {
          label: "center",
          value: "center",
        },
        {
          label: "right",
          value: "right",
        },
      ],
      disabled: false,
    },
    {
      name: "pages",
      defaultValue: null,
      validation: [],
      type: "string",
      validValues: [],
      disabled: false,
    },
    {
      name: "color",
      defaultValue: null,
      validation: [],
      type: "text",
      validValues: [],
      disabled: false,
      hint: (
        <div>
          Enter color in a form of <code>#RRGGBB</code> or{" "}
          <code>#AARRGGBB</code> (with transparency). Check supported color
          values
          <a
            target="popup"
            onClick={() => {
              openCenterPopup(
                "https://apidocs.pdf.co/kb/Fill%20PDF%20and%20Add%20Text%20or%20Images%20(pdf-edit-add)/text-colors",
                800,
                600
              );
              return false;
            }}
            className="ms-1"
          >
            here
          </a>
        </div>
      ),
    },
    {
      name: "link",
      defaultValue: null,
      validation: [],
      type: "string",
      validValues: [],
      disabled: false,
    },
    {
      name: "size",
      defaultValue: null,
      validation: [
        {
          type: "number",
          min: 1,
          message: "Size input must be greater than 1!",
        },
      ],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontName",
      defaultValue: null,
      validation: [],
      type: "select",
      validValues: [...FontListForAnnotations],
      disabled: false,
    },
    {
      name: "fontBold",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontStrikeout",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontUnderline",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontItalic",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "transparent",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "type",
      defaultValue: null,
      validation: [],
      type: "select",
      validValues: [
        {
          label: "text object",
          value: "text",
        },
        {
          label: "text input field",
          value: "textfield",
        },
        {
          label: "checkbox field",
          value: "checkbox",
        },
      ],
      disabled: false,
    },
    {
      name: "id",
      defaultValue: null,
      validation: [],
      type: "string",
      validValues: [],
      disabled: false,
    },
  ],
};
